import { useState, useRef } from 'react'
import { Box, Paper, FormControl, InputLabel, Input, InputAdornment, IconButton, ImageList, Button, FormHelperText } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Image } from '@material-ui/icons'
import { uploadMedia, deleteMedia } from 'containers/Examination/ExaminationService'

import './OptionBuilder.css'

const OptionBuilder = (props) => {
  const { optionCreated, options } = props
  const optionImageInput = useRef(null)
  const MAX_OPTIONS = 4

  const addOptionImage = () => {
    optionImageInput.current.click()
  }

  const [uploadingImage, setUploadingImage] = useState(false)
  const [optionImagePreview, setOptionImagePreview] = useState('')

  const showOptionImagePreview = async (e) => {
    setUploadingImage(true)
    const selectedFile = e.target.files[0]

    let formData = new FormData()
    formData.append('media', selectedFile)

    const image = await uploadMedia(formData)

    setOptionImagePreview(image.photo_url)
    setOptionImage(image)
    setUploadingImage(false)
  }

  const [optionText, setOptionText] = useState('')
  const [optionImage, setOptionImage] = useState(null)

  const [descriptionHelperText, setDescriptionHelperText] = useState('')
  const [descriptionHasError, setDescriptionHasError] = useState(false)

  const [showMessageBanner, setShowMessaegBanner] = useState(false)

  const addOption = () => {
    setDescriptionHelperText('')
    setDescriptionHasError(false)
    setShowMessaegBanner(false)

    if (optionText === "") {
      setDescriptionHelperText('This field is required')
      setDescriptionHasError(true)
      return
    }

    if (options.length + 1 > MAX_OPTIONS) {
      setShowMessaegBanner(true)
      return
    }

    optionCreated(optionText, optionImage)
    setOptionText('')
    setOptionImagePreview(null)
    setOptionImage(null)
  }

  return (
    <Box>
      <Box>
        {showMessageBanner && <Alert className="message-banner" severity="error">Oops! That's too many options. You can only add {MAX_OPTIONS} options</Alert>}
        <FormControl fullWidth>
          <InputLabel>Option</InputLabel>
          <Input
            type="text"
            variant="outlined"
            value={optionText}
            onChange={(e) => setOptionText(e.target.value)}
            error={descriptionHasError}
            fullWidth
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={addOptionImage}
                >
                  <Image />
                </IconButton>
                <input id="option-image-input" ref={optionImageInput} type="file" onChange={showOptionImagePreview} />
              </InputAdornment>
            }
          />
          <FormHelperText error={descriptionHasError}>{descriptionHelperText}</FormHelperText>
        </FormControl>
      </Box>
      <Box display="flex">
        <Box flexGrow={1}>
          <img style={{width: '200px'}} src={optionImagePreview} alt="" />
          <ImageList rowHeight={160} cols={3}>
            {uploadingImage && "Uploading image..."}
          </ImageList>
        </Box>
        <Box>
          <Button
            color="primary"
            variant="contained"
            onClick={addOption}
          >
            Add Option
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default OptionBuilder